(function () {
  'use strict';

  // ================================================================
  //  CONFIGURATION — modifier ici pour ajuster les tarifs
  // ================================================================

  // Prix HT au m² par support (€/m²)
  // Matières manquantes (prix à confirmer) marquées TODO
  var PRIX_M2 = {
    'thermique':              0.340,
    'thermique-top':          0.430,
    'thermique-top-double':   0.860,  // thermique-top × 2
    'thermique-top-amovible': 0.645,  // thermique-top × 1.5
    'papier-couche':          0.300,
    'papier-couche-double':   0.600,  // papier-couche × 2
    'papier-velin':           0.300,
    'papier-fluo':            0.708,
    'polypro-blanc-brillant': 0.430,
    'polypro-mat':            0.430,
    'polypro-transparent':    0.410,
    'polyethylene':           0.532,
    'polyester':              1.560,
    'polyester-argente':      1.760,
    'hydrosoluble':           0.300,  // TODO — prix à confirmer
    'pvc':                    0.985,
  };

  // Marges (mm) ajoutées aux dimensions saisies par le client
  var MARGE_LARGEUR = 6;
  var MARGE_HAUTEUR = 4;

  // Multiplicateur de production (fixe pour toutes les matières)
  var MULTIPLICATEUR = 3;

  // Surcoût couleurs (coefficient multiplicateur sur le prix total)
  var COEF_COULEURS = {
    'sans-impression': 1.00,
    'noir':            1.15,
    '1-couleur':       1.30,
    '2-couleurs':      1.40,
    '3-couleurs':      1.50,
  };

  // Pas de surcoût adhésifs
  var COEF_ADHESIFS = {
    'permanent':          1.00,
    'permanent-renforce': 1.00,
    'amovible':           1.00,
  };

  // Surcoût finitions
  var COEF_FINITIONS = {
    'sans':                 1.00,
    'vernis-brillant':      1.20,  // +20 %
    'vernis-mat':           1.20,  // +20 %
    'pelliculage-mat':      1.30,  // +30 %
    'pelliculage-brillant': 1.30,  // +30 %
  };

  // ================================================================
  //  FIN CONFIGURATION
  // ================================================================

  var state = {
    step:       1,
    type:       'rouleaux',
    quantite:   30000,
    largeur:    50,
    hauteur:    50,
    forme:      'rectangulaire',
    support:    'thermique',
    adhesif:    'permanent',
    couleur:    'noir',
    finition:   'sans',
    bat: 'sans-bat',
    supportTouched: false,
  };

  // ---------------------------------------------------------------
  //  Calcul du prix
  //  Formule : (L+6) × (H+4) × quantite / 1 000 000 × prix_m2 × 3 × coefs
  // ---------------------------------------------------------------
  function calculerPrix(cfg, quantite) {
    var largeurEff = cfg.largeur + MARGE_LARGEUR;
    var hauteurEff = cfg.hauteur + MARGE_HAUTEUR;
    var surfaceM2  = largeurEff * hauteurEff * quantite / 1000000;
    var prixM2     = PRIX_M2[cfg.support] || PRIX_M2['papier-couche'];
    var coefC      = COEF_COULEURS[cfg.couleur]  || 1.0;
    var coefA      = COEF_ADHESIFS[cfg.adhesif]  || 1.0;
    var coefF      = COEF_FINITIONS[cfg.finition] || 1.0;

    var total = surfaceM2 * prixM2 * MULTIPLICATEUR * coefC * coefA * coefF;
    total = Math.round(total * 100) / 100;
    var unite = quantite > 0 ? Math.round(total / quantite * 100000) / 100000 : 0;
    return { total: total, unite: unite };
  }

  // ---------------------------------------------------------------
  //  Formatage des prix
  // ---------------------------------------------------------------
  function fmt(n) {
    return n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function fmtUnit(n) {
    var digits = n < 0.01 ? 4 : (n < 0.1 ? 3 : 2);
    return n.toLocaleString('fr-FR', { minimumFractionDigits: digits, maximumFractionDigits: digits }) + ' €';
  }

  // ---------------------------------------------------------------
  //  Dates de production (jours ouvrés)
  // ---------------------------------------------------------------
  function addBusinessDays(date, n) {
    var d = new Date(date);
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) added++;
    }
    return d;
  }
  function fmtDate(d) {
    return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  // ---------------------------------------------------------------
  //  Mise à jour du récapitulatif
  // ---------------------------------------------------------------
  function updateRecap() {
    checkRebuildQtyTable();
    var prix = calculerPrix(state, state.quantite);

    var elTotal = document.getElementById('cfg-total');
    var elUnite = document.getElementById('cfg-unite');
    if (elTotal) elTotal.textContent = fmt(prix.total);
    if (elUnite) elUnite.textContent = 'Prix à l\'unité : ' + fmtUnit(prix.unite);

    // Tableau des quantités standard
    var tbody = document.getElementById('cfg-qty-tbody');
    if (tbody) {
      tbody.querySelectorAll('tr').forEach(function (row) {
        var q = parseInt(row.dataset.qty);
        if (!q) return;
        var p = calculerPrix(state, q);
        var tdTotal = row.querySelector('.cfg-td-total');
        var tdUnit  = row.querySelector('.cfg-td-unit');
        if (tdTotal) tdTotal.textContent = fmt(p.total);
        if (tdUnit)  tdUnit.textContent  = fmtUnit(p.unite);

        // Surligner la ligne la plus proche de la quantité saisie
        var closest = findClosestStdQty(state.quantite);
        row.classList.toggle('cfg-row-selected', q === closest);
      });
    }

    // Dates d'envoi estimées selon BAT
    var main = document.getElementById('cfg-main');
    if (main) {
      var now  = new Date();
      var dStd = parseInt(main.dataset.delaiStd || '10');
      var dBat = parseInt(main.dataset.delaiBat || '12');
      var elStd = document.getElementById('cfg-date-std');
      var elBat = document.getElementById('cfg-date-bat');
      if (elStd) elStd.textContent = fmtDate(addBusinessDays(now, dStd));
      if (elBat) elBat.textContent = fmtDate(addBusinessDays(now, dBat));
    }

    updateMatchBanner();
  }

  // ---------------------------------------------------------------
  //  Catalogue — détection produit existant en stock
  // ---------------------------------------------------------------
  var CATALOG_PARSED = null;

  var SUPPORT_MAP = [
    { re: /thermique\s+top/,                          val: 'thermique-top' },
    { re: /thermique/,                                 val: 'thermique' },
    { re: /papier\s+cou[vc]h|couche?\s+blanc/,        val: 'papier-couche' },
    { re: /velin/,                                     val: 'papier-velin' },
    { re: /fluo/,                                      val: 'papier-fluo' },
    { re: /polypropyl[eè]ne.*mat/,                    val: 'polypro-mat' },
    { re: /polypropyl[eè]ne.*transparent/,            val: 'polypro-transparent' },
    { re: /polypropyl[eè]ne/,                         val: 'polypro-blanc-brillant' },
    { re: /polyester\s+argent[eé]/,                   val: 'polyester-argente' },
    { re: /polyester/,                                 val: 'polyester' },
    { re: /polyéthylène|polyethylene|polyéthylene/,   val: 'polyethylene' },
    { re: /\bpvc\b/,                                   val: 'pvc' },
  ];

  function parseProductTitle(title) {
    var t = title.toLowerCase();
    var m = t.match(/(\d+[,.]?\d*)\s*[x×]\s*(\d+[,.]?\d*)\s*mm/);
    if (!m) return null;
    var l = Math.round(parseFloat(m[1].replace(',', '.')));
    var h = Math.round(parseFloat(m[2].replace(',', '.')));
    var support = null;
    for (var i = 0; i < SUPPORT_MAP.length; i++) {
      if (SUPPORT_MAP[i].re.test(t)) { support = SUPPORT_MAP[i].val; break; }
    }
    if (!support) return null;
    var adhesif = /amovible/.test(t) ? 'amovible'
                : /permanent\s+renforc/.test(t) ? 'permanent-renforce'
                : 'permanent';

    // Nombre total d'étiquettes dans le produit (ex: "10 RLX - 1000 étiquettes" → 10 000)
    var rlx = 1;
    var rlxM = t.match(/^(\d+)\s*rlx/);
    if (rlxM) rlx = parseInt(rlxM[1]);
    var countM = t.match(/(\d[\d\s]*)\s*[ée]tiquettes/);
    var totalLabels = 0;
    if (countM) {
      var n = parseInt(countM[1].replace(/\s/g, ''));
      if (n > 0 && n < 500000) totalLabels = rlx * n;
    }

    return { l: l, h: h, support: support, adhesif: adhesif, totalLabels: totalLabels };
  }

  function loadCatalog(callback) {
    var p1 = fetch('/products.json?limit=250').then(function(r) { return r.json(); });
    var p2 = fetch('/products.json?limit=250&page=2').then(function(r) { return r.json(); });
    Promise.all([p1, p2]).then(function(results) {
      var all = (results[0].products || []).concat(results[1].products || []);
      CATALOG_PARSED = all.map(function(p) {
        var parsed = parseProductTitle(p.title);
        if (!parsed || !parsed.totalLabels) return null;
        var price = parseFloat((p.variants && p.variants[0]) ? p.variants[0].price : '0');
        if (!price) return null;
        return {
          handle: p.handle, title: p.title,
          l: parsed.l, h: parsed.h,
          support: parsed.support, adhesif: parsed.adhesif,
          totalLabels: parsed.totalLabels, price: price,
        };
      }).filter(Boolean);
      if (callback) callback();
    }).catch(function(err) { console.error('[CFG] Erreur catalog:', err); CATALOG_PARSED = []; });
  }

  function findCatalogMatch() {
    if (!CATALOG_PARSED) return null;
    var l = state.largeur, h = state.hauteur;
    // "permanent-renforce" matchable avec "permanent" (les produits stock n'ont pas de référence renforcé distincte)
    var adhesifMatch = state.adhesif === 'permanent-renforce' ? 'permanent' : state.adhesif;
    for (var i = 0; i < CATALOG_PARSED.length; i++) {
      var p = CATALOG_PARSED[i];
      if (p.support !== state.support) continue;
      if (p.adhesif !== adhesifMatch) continue;
      if ((p.l === l && p.h === h) || (p.l === h && p.h === l)) return p;
    }
    return null;
  }

  // Cache des tiers déjà fetchés (évite les requêtes répétées)
  var tiersCache = {};

  function parsePrixStr(s) {
    if (!s) return 0;
    return parseFloat(String(s).replace(/\s/g, '').replace('€', '').replace(',', '.')) || 0;
  }

  function applyTiers(match, tiers) {
    if (!tiers || tiers.length === 0) return;
    var tbody = document.getElementById('cfg-qty-tbody');
    if (!tbody) return;

    // Reconstruction du tableau avec les vrais paliers
    var html = '';
    tiers.forEach(function (tier, i) {
      var totalLabels = tier.cartons * match.totalLabels;
      // prix_carton = prix total pour ce palier (toutes cartons confondus)
      var prixTotal = Math.round(parsePrixStr(tier.prix_carton) * 100) / 100;
      // Fallback : prix/rouleau × totalLabels
      if (!prixTotal) prixTotal = Math.round(parsePrixStr(tier.prix) * tier.cartons * 100) / 100;
      var prixUnite = totalLabels > 0 ? prixTotal / totalLabels : 0;
      var badge = (i === tiers.length - 1) ? ' <span class="cfg-qty-badge">Meilleur prix</span>' : '';
      var qtyLabel = totalLabels.toLocaleString('fr-FR');
      var sel = (totalLabels === findClosestTierQty(tiers, match)) ? ' class="cfg-row-selected"' : '';
      html += '<tr data-qty="' + totalLabels + '"' + sel + '>'
            + '<td class="cfg-td-qty">' + qtyLabel + badge + '</td>'
            + '<td class="cfg-td-total">' + fmt(prixTotal) + '</td>'
            + '<td class="cfg-td-unit">' + fmtUnit(prixUnite) + '</td>'
            + '</tr>';
    });
    tbody.innerHTML = html;

    // Prix principal : palier le plus adapté à la quantité saisie
    var bestTier = getBestTier(tiers, match);
    var bestTotal = Math.round(parsePrixStr(bestTier.prix_carton) * 100) / 100 || parsePrixStr(bestTier.prix) * bestTier.cartons;
    var bestLabels = bestTier.cartons * match.totalLabels;
    var ppl = bestLabels > 0 ? bestTotal / bestLabels : 0;
    var elTotal = document.getElementById('cfg-total');
    var elUnite = document.getElementById('cfg-unite');
    if (elTotal) elTotal.textContent = fmt(Math.round(ppl * state.quantite * 100) / 100);
    if (elUnite) elUnite.textContent = 'Prix à l\'unité : ' + fmtUnit(ppl) + ' (prix catalogue)';
  }

  function getBestTier(tiers, match) {
    // Tier dont le totalLabels est ≥ state.quantite, ou le dernier (plus grosse quantité)
    var best = tiers[0];
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].cartons * match.totalLabels <= state.quantite) best = tiers[i];
    }
    return best;
  }

  function findClosestTierQty(tiers, match) {
    var q = state.quantite;
    var best = tiers[0].cartons * match.totalLabels;
    tiers.forEach(function (t) {
      var tq = t.cartons * match.totalLabels;
      if (Math.abs(tq - q) < Math.abs(best - q)) best = tq;
    });
    return best;
  }

  function fetchAndApplyTiers(match) {
    if (tiersCache[match.handle] !== undefined) {
      var cached = tiersCache[match.handle];
      if (cached.length > 0) applyTiers(match, cached);
      else applyDefaultTiers(match);
      return;
    }
    fetch('/products/' + match.handle + '?view=cfg-data')
      .then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.json();
      })
      .then(function (tiers) {
        var arr = Array.isArray(tiers) ? tiers : [];
        tiersCache[match.handle] = arr;
        if (arr.length > 0) applyTiers(match, arr);
        else applyDefaultTiers(match);
      })
      .catch(function () { /* ne pas cacher l'échec : on réessaiera */ });
  }

  function updateMatchBanner() {
    var banner = document.getElementById('cfg-match-banner');
    var link   = document.getElementById('cfg-match-link');
    if (!banner || !link) return;
    if (!state.supportTouched) { banner.style.display = 'none'; return; }
    var match = findCatalogMatch();
    if (match) {
      link.href        = '/products/' + match.handle;
      link.textContent = match.title + ' →';
      banner.style.display = '';
      fetchAndApplyTiers(match);
    } else {
      banner.style.display = 'none';
      if (CATALOG_PARSED) applyFormulaWithDiscounts();
    }
  }

  var QUANTITES = {
    blanc:   [30000, 50000, 100000, 200000, 500000],
    couleur: [30000, 50000, 100000, 200000, 500000],
  };

  // Paliers de remises par défaut (produits sans prix_degressifs ou hors catalogue)
  var DEFAULT_DISC = [
    { mult: 1,  pct: 0  },
    { mult: 2,  pct: 5  },
    { mult: 3,  pct: 10 },
    { mult: 5,  pct: 20 },
    { mult: 10, pct: 35 },
    { mult: 50, pct: 50 },
  ];

  function buildDiscountTable(minQ, basePPL, label) {
    var selQty = minQ;
    DEFAULT_DISC.forEach(function (d) {
      if (d.mult * minQ <= state.quantite) selQty = d.mult * minQ;
    });
    var html = '';
    DEFAULT_DISC.forEach(function (d, i) {
      var qty   = d.mult * minQ;
      var ppl   = basePPL * (1 - d.pct / 100);
      var total = Math.round(ppl * qty * 100) / 100;
      var isLast = i === DEFAULT_DISC.length - 1;
      var badge = isLast
        ? '<span class="cfg-qty-badge">Meilleur prix</span>'
        : (d.pct > 0 ? '<span class="cfg-qty-badge">-' + d.pct + '%</span>' : '');
      var sel = (qty === selQty) ? ' class="cfg-row-selected"' : '';
      html += '<tr data-qty="' + qty + '"' + sel + '>'
            + '<td class="cfg-td-qty">' + qty.toLocaleString('fr-FR') + badge + '</td>'
            + '<td class="cfg-td-total">' + fmt(total) + '</td>'
            + '<td class="cfg-td-unit">' + fmtUnit(ppl) + '</td>'
            + '</tr>';
    });
    var tbody = document.getElementById('cfg-qty-tbody');
    if (tbody) tbody.innerHTML = html;
    var bestPct = 0;
    DEFAULT_DISC.forEach(function (d) {
      if (d.mult * minQ <= state.quantite) bestPct = d.pct;
    });
    var ppl = basePPL * (1 - bestPct / 100);
    var elTotal = document.getElementById('cfg-total');
    var elUnite = document.getElementById('cfg-unite');
    if (elTotal) elTotal.textContent = fmt(Math.round(ppl * state.quantite * 100) / 100);
    if (elUnite) elUnite.textContent = 'Prix à l\'unité : ' + fmtUnit(ppl) + (label ? ' ' + label : '');
  }

  function applyDefaultTiers(match) {
    if (!match.price || !match.totalLabels) return;
    buildDiscountTable(match.totalLabels, match.price / match.totalLabels, '(prix catalogue)');
  }

  function applyFormulaWithDiscounts() {
    var minQ    = getQuantitesList()[0];
    var basePPL = calculerPrix(state, minQ).unite * 2; // ×2 pour formats hors catalogue
    buildDiscountTable(minQ, basePPL, '(sur mesure)');
  }

  function getCouleurGroup() {
    return (state.couleur === 'noir' || state.couleur === 'sans-impression') ? 'blanc' : 'couleur';
  }

  function getQuantitesList() {
    return QUANTITES[getCouleurGroup()];
  }

  function findClosestStdQty(q) {
    return getQuantitesList().reduce(function (prev, curr) {
      return Math.abs(curr - q) < Math.abs(prev - q) ? curr : prev;
    });
  }

  var _lastCouleurGroup = null;

  function rebuildQtyTable() {
    var tbody = document.getElementById('cfg-qty-tbody');
    if (!tbody) return;
    var list = getQuantitesList();
    var html = '';
    list.forEach(function (q, i) {
      var badge = (i === list.length - 1) ? ' <span class="cfg-qty-badge">Meilleur prix</span>' : '';
      var label = q.toLocaleString('fr-FR');
      html += '<tr data-qty="' + q + '"><td class="cfg-td-qty">' + label + badge + '</td>'
            + '<td class="cfg-td-total">—</td><td class="cfg-td-unit">—</td></tr>';
    });
    tbody.innerHTML = html;
    // Ajuster l'input quantité au nouveau minimum
    var inputQ = document.getElementById('cfg-quantite');
    if (inputQ) {
      var minQ = list[0];
      inputQ.min = minQ;
      if (parseInt(inputQ.value) < minQ) {
        inputQ.value = minQ;
        state.quantite = minQ;
      }
    }
  }

  function checkRebuildQtyTable() {
    var group = getCouleurGroup();
    if (group !== _lastCouleurGroup) {
      _lastCouleurGroup = group;
      rebuildQtyTable();
    }
  }

  // ---------------------------------------------------------------
  //  Navigation entre étapes
  // ---------------------------------------------------------------
  function goToStep(n) {
    document.querySelectorAll('.cfg-step').forEach(function (s) {
      s.classList.remove('active');
    });
    document.querySelectorAll('.cfg-tab').forEach(function (t, i) {
      t.classList.remove('active', 'completed');
      if (i + 1 === n)     t.classList.add('active');
      else if (i + 1 < n) t.classList.add('completed');
    });
    var target = document.querySelector('.cfg-step[data-step="' + n + '"]');
    if (target) target.classList.add('active');
    state.step = n;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'configurateur_step', cfg_step: n });
    var panel = document.querySelector('.cfg-panel');
    if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ---------------------------------------------------------------
  //  Lecture des champs
  // ---------------------------------------------------------------
  function readInputs() {
    var q = parseInt(document.getElementById('cfg-quantite').value) || 500;
    var l = parseInt(document.getElementById('cfg-largeur').value)  || 50;
    var h = parseInt(document.getElementById('cfg-hauteur').value)  || 50;
    state.quantite = Math.max(30000, q);
    state.largeur  = Math.max(10, Math.min(500, l));
    state.hauteur  = Math.max(10, Math.min(500, h));
  }

  // ---------------------------------------------------------------
  //  Texte du devis pour mailto
  // ---------------------------------------------------------------
  function genDevis() {
    var p = calculerPrix(state, state.quantite);
    return [
      'Demande de devis — Étiquettes sur mesure',
      '=========================================',
      'Type         : Étiquettes en ' + state.type,
      'Quantité     : ' + state.quantite.toLocaleString('fr-FR'),
      'Dimensions   : ' + state.largeur + ' × ' + state.hauteur + ' mm',
      'Forme        : ' + state.forme,
      'Support      : ' + state.support,
      'Adhésif      : ' + state.adhesif,
      'Couleur      : ' + state.couleur,
      'Finition     : ' + state.finition,
      'BAT          : ' + (state.bat === 'bat-numerique' ? 'BAT numérique' : 'Sans BAT'),
      '',
      'PRIX ESTIMÉ HT : ' + fmt(p.total),
      'Prix à l\'unité : ' + fmtUnit(p.unite),
      '',
      '— EtiquettesPro.fr',
    ].join('\n');
  }

  // ---------------------------------------------------------------
  //  Initialisation
  // ---------------------------------------------------------------
  document.addEventListener('DOMContentLoaded', function () {

    // Sélecteurs type / forme (boutons data-field)
    document.querySelectorAll('[data-field]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var field = this.dataset.field;
        var value = this.dataset.value;
        document.querySelectorAll('[data-field="' + field + '"]').forEach(function (b) {
          b.classList.remove('active');
        });
        this.classList.add('active');
        state[field] = value;
        if (field === 'support') state.supportTouched = true;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'configurateur_field', cfg_field: field, cfg_value: value });
        updateRecap();
      });
    });

    // Inputs numériques
    ['cfg-quantite', 'cfg-largeur', 'cfg-hauteur'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('input', function () { readInputs(); updateRecap(); });
    });

    // Radio items (support, adhésif, couleur, finition) — change sur l'input, plus fiable que click sur le label
    document.querySelectorAll('.cfg-radio-item input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', function () {
        var name = this.name;
        var val  = this.value;
        document.querySelectorAll('.cfg-radio-item input[name="' + name + '"]').forEach(function (r) {
          r.closest('.cfg-radio-item').classList.remove('active');
        });
        this.closest('.cfg-radio-item').classList.add('active');
        if (name === 'support')  { state.support = val; state.supportTouched = true; }
        if (name === 'adhesif')  state.adhesif  = val;
        if (name === 'couleur')  state.couleur  = val;
        if (name === 'finition') state.finition = val;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'configurateur_field', cfg_field: name, cfg_value: val });
        updateRecap();
      });
    });

    // Navigation
    document.querySelectorAll('[data-next]').forEach(function (btn) {
      btn.addEventListener('click', function () { readInputs(); goToStep(parseInt(this.dataset.next)); });
    });
    document.querySelectorAll('[data-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () { goToStep(parseInt(this.dataset.prev)); });
    });

    // Tabs cliquables (retour aux étapes précédentes)
    document.querySelectorAll('.cfg-tab').forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        if (this.classList.contains('completed')) goToStep(i + 1);
      });
    });

    // Boutons "Mettre à jour"
    document.querySelectorAll('.cfg-btn-update').forEach(function (btn) {
      btn.addEventListener('click', function () { readInputs(); updateRecap(); });
    });

    // Sélecteur BAT
    document.querySelectorAll('.cfg-prod-option').forEach(function (opt) {
      opt.addEventListener('click', function () {
        document.querySelectorAll('.cfg-prod-option').forEach(function (o) {
          o.classList.remove('selected');
        });
        this.classList.add('selected');
        state.bat = this.dataset.prod;
      });
    });

    // Clic sur une ligne du tableau → sélectionner cette quantité (event delegation)
    var qtyTbody = document.getElementById('cfg-qty-tbody');
    if (qtyTbody) {
      qtyTbody.addEventListener('click', function (e) {
        var row = e.target.closest('tr[data-qty]');
        if (!row) return;
        var q = parseInt(row.dataset.qty);
        if (!q) return;
        state.quantite = q;
        var inputQ = document.getElementById('cfg-quantite');
        if (inputQ) inputQ.value = q;
        updateRecap();
      });
    }

    // Upload fichier — drag & drop + clic
    var uploadLabel = document.getElementById('cfg-upload-label');
    var uploadInput = document.getElementById('cfg-fichier');
    var uploadText  = document.getElementById('cfg-upload-text');

    function setFile(file) {
      if (!file) return;
      var maxMo = 50;
      if (file.size > maxMo * 1024 * 1024) {
        alert('Le fichier dépasse ' + maxMo + ' Mo. Merci de le compresser ou de nous l\'envoyer par email.');
        return;
      }
      uploadText.textContent = '✓ ' + file.name;
      uploadLabel.classList.add('has-file');
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'configurateur_file_upload', cfg_file_name: file.name });
    }

    if (uploadInput) {
      uploadInput.addEventListener('change', function () {
        setFile(this.files[0]);
      });
    }
    if (uploadLabel) {
      uploadLabel.addEventListener('dragover', function (e) {
        e.preventDefault();
        this.classList.add('dragover');
      });
      uploadLabel.addEventListener('dragleave', function () {
        this.classList.remove('dragover');
      });
      uploadLabel.addEventListener('drop', function (e) {
        e.preventDefault();
        this.classList.remove('dragover');
        var file = e.dataTransfer.files[0];
        if (file && uploadInput) {
          var dt = new DataTransfer();
          dt.items.add(file);
          uploadInput.files = dt.files;
        }
        setFile(file);
      });
    }

    // Devis email
    var devisLink = document.getElementById('cfg-devis');
    if (devisLink) {
      devisLink.addEventListener('click', function (e) {
        e.preventDefault();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'configurateur_devis',
          cfg_support:  state.support,
          cfg_largeur:  state.largeur,
          cfg_hauteur:  state.hauteur,
          cfg_quantite: state.quantite,
          cfg_couleur:  state.couleur,
          cfg_finition: state.finition,
          cfg_adhesif:  state.adhesif,
        });
        var email   = this.dataset.email || 'contact@etiquettespro.fr';
        var subject = encodeURIComponent('Devis étiquettes sur mesure');
        var body    = encodeURIComponent(genDevis());
        window.location.href = 'mailto:' + email + '?subject=' + subject + '&body=' + body;
      });
    }

    // Valider ma commande → envoie le devis par email
    var cartBtn = document.getElementById('cfg-add-cart');
    if (cartBtn) {
      cartBtn.addEventListener('click', function () {
        readInputs();
        var emailLink = document.getElementById('cfg-devis');
        if (emailLink) emailLink.click();
      });
    }

    // Premier rendu + chargement catalogue pour matching
    rebuildQtyTable();
    updateRecap();
    loadCatalog(updateMatchBanner);
  });

})();
